import { ArrowLeft } from 'lucide-react'
import { LegalContent, legalTitle, type LegalDoc } from './LegalModal'

/**
 * Standalone, link-stable legal page rendered at /privacy and /terms (and
 * their /privacy-policy, /terms-of-service, /terms-and-conditions aliases).
 *
 * App-store listings (Play Console, App Store Connect) and the in-app
 * footer link to these canonical URLs, so they must resolve to a real,
 * crawlable page — not just the Footer modal. The SPA fallback in
 * public/_redirects serves index.html for every path; this component reads
 * window.location.pathname (via App.tsx) and renders the matching doc.
 */
export function LegalPage({ doc }: { doc: LegalDoc }) {
  const title = legalTitle(doc)
  return (
    <div className="min-h-screen bg-[var(--color-canvas,#f7f8fa)]">
      <header className="border-b border-[var(--color-divider)] bg-white">
        <div className="mx-auto flex max-w-3xl items-center gap-3 px-5 py-4 sm:px-6">
          <a
            href="/"
            aria-label="Back to BimaUncle home"
            className="flex items-center gap-2 text-ink-soft hover:text-ink"
          >
            <ArrowLeft size={20} />
            <img src="/logo.png" alt="BimaUncle" className="h-8 w-auto" />
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-8 sm:px-6 sm:py-10">
        <h1 className="mb-6 text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        <div className="text-[15px] leading-relaxed text-ink">
          <LegalContent doc={doc} />
        </div>
        <div className="mt-10 border-t border-[var(--color-divider)] pt-6">
          <a href="/" className="font-semibold text-brand underline">
            ← Back to home
          </a>
        </div>
      </main>
    </div>
  )
}
